<template>
  <div class="plan-card">
    <div v-if="cardState === cardStates.SelectPlansView">


      <div class="card-header top-radius is-flex">
        <span style="padding: 3px">{{ $t('Internet') }}</span>
      </div>
      <div style="background-color: white; padding: 15px 15px 40px">
        <vue-slider :style="{ paddingTop: '20px', paddingBottom: '20px'}" :reverse="language === 'ar'"
                    :height="8" :direction="$store.getters.getDir()"
                    v-model="pickedPlan.valueGBs" :dot-width="3" :tooltip="'none'"
                    :data="$store.getters.getSettings().DATA"
                    :marks="true" class="padding-bottom-1">
          <div class="slider-dot" slot="dot"></div>
          <div :class="label === pickedPlan.valueGBs? 'has-text-weight-bold' : ''" class="slider-label"
               slot="label"
               slot-scope="{ pos, label }">
            <span>{{ label.isUnlimited ? $t('UL') : label.value.replace('.0', '') }}<br>GB</span>
          </div>
        </vue-slider>
      </div>


      <div class="card-header is-flex">
        <span>{{ $t('ZainToZain') }}</span>
        <div style="flex-grow: 1"/>
      </div>
      <div style="background-color: white; padding: 15px 15px 40px">
        <vue-slider :reverse="language === 'ar'" :height="8" :direction="$store.getters.getDir()"
                    v-model="pickedPlan.valueMinutesOnNet" :dot-width="3" :tooltip="'none'"
                    :data="$store.getters.getSettings().ONNETMINUTES"
                    :disabled="pickedPlan.valueMinutesOffNet.isUnlimited"
                    :marks="true" class="padding-bottom-1">
          <div class="slider-dot" slot="dot"></div>
          <div :class="label === pickedPlan.valueMinutesOnNet? 'has-text-weight-bold' : ''"
               class="slider-label"
               slot="label" slot-scope="{ pos, label }">
            <span>{{ label.isUnlimited ? $t('UL') : label.value.replace('.0', '') }}</span>
          </div>
        </vue-slider>
      </div>


      <div class="card-header is-flex">
        <span>{{ $t('LocalMinutes') }}</span>
        <div style="flex-grow: 1"/>
      </div>
      <div style="background-color: white; padding: 15px 15px 40px">
        <vue-slider :reverse="language === 'ar'" :height="8" :direction="$store.getters.getDir()"
                    v-model="pickedPlan.valueMinutesOffNet" :dot-width="3" :tooltip="'none'"
                    :data="$store.getters.getSettings().LOCALMINUTES"
                    :marks="true" class="padding-bottom-1">
          <div class="slider-dot" slot="dot"></div>
          <div :class="label === pickedPlan.valueMinutesOffNet? 'has-text-weight-bold' : ''"
               class="slider-label"
               slot="label" slot-scope="{ pos, label }">
            <span>{{ label.isUnlimited ? $t('UL') : label.value.replace('.0', '') }}</span>
          </div>

        </vue-slider>
      </div>

      <div class="card-header align-left">
        <span>{{ $t('InternationalMinutes') }}</span>
      </div>
      <div style="background-color: white; padding: 15px 15px 40px">
        <vue-slider :reverse="language === 'ar'" :height="8" :direction="$store.getters.getDir()"
                    v-model="pickedPlan.valueInternationalMinutes" :dot-width="3" :tooltip="'none'"
                    :data="$store.getters.getSettings().INTERNATIONALMINUTES"
                    :marks="true" class="padding-bottom-1">
          <div class="slider-dot" slot="dot"></div>
          <div :class="label === pickedPlan.valueInternationalMinutes? 'has-text-weight-bold' : ''"
               class="slider-label"
               slot="label" slot-scope="{ pos, label }">
            <span>{{ label.isUnlimited ? $t('UL') : label.value.replace('.0', '') }}</span>
          </div>
        </vue-slider>
      </div>


      <div class="card-header align-left">
        <span class="margin-0">{{ $t('AdditionalBenefits') }}</span>
      </div>
      <div class="card-footer" style="background-color: white; padding: 0 10px; margin-bottom: 50px">
        <div class="benefits-list">
          <div
              style="padding-top: 5px;">
            <div class="align-left" style="margin-top: 5px;">
              <div class="align-left">
                <img style="width: 40px;" alt="WhatsApp" src="../assets/wa.png">
              </div>
              <div class="display-inline-block align-left">
                <span class="benefit-1">{{ $t('WhatsApp') }} {{ $t('Unlimited') }}</span>
              </div>
              <b-switch class="float-right is-rounded" style="margin-top: -25px"
                        :false-value="$store.getters.getSettings().WHATSAPP[0]"
                        :true-value="$store.getters.getSettings().WHATSAPP[1]"
                        v-model="pickedPlan.valueWhatsApp" size="is-medium"
                        type="is-success">
              </b-switch>
            </div>
            <hr style="margin: 0 auto; width: 95%;"/>
          </div>

          <div
              style="padding-top: 5px;">
            <div class="align-left" style="margin-top: 5px;">
              <div>
                <img alt="WhatsApp" src="../assets/tw.png" style="display: inline-block; width: 40px;">
                <img alt="WhatsApp" src="../assets/fb.png" style="display: inline-block; width: 40px;">
                <img alt="WhatsApp" src="../assets/in.png" style="display: inline-block; width: 40px;">
                <img alt="WhatsApp" src="../assets/sc.png" style="display: inline-block; width: 40px;">
              </div>
              <div class="display-inline-block">
                <span class="benefit-1">{{ $t('SocialMedia') }} {{ $t('Unlimited') }}</span>
              </div>
              <b-switch class="float-right is-rounded" style="margin-top: -25px"
                        :false-value="$store.getters.getSettings().SOCIALMEDIA[0]"
                        :true-value="$store.getters.getSettings().SOCIALMEDIA[1]"
                        v-model="pickedPlan.valueSocialMedia" size="is-medium"
                        type="is-success">
              </b-switch>
              <div style="padding-bottom: 5px" v-if="$store.getters.getSettings().SOCIALMEDIA[1].price === '0'">
                <i class="fa fa-star" style="color: #FFC107"></i>
                <b> {{ $t('Free') }} </b>{{ $t('Free30Days') }}
              </div>
            </div>
            <hr style="margin: 0 auto; width: 95%;"/>

          </div>

          <div
              style="padding-top: 5px;">
            <div class="align-left" style="margin-top: 5px;">
              <div>
                <img style="width: 40px;" alt="YouTube" src="../assets/yt.png">
              </div>
              <div class="display-inline-block">
                <span class="benefit-1">{{ $t('YouTube') }} {{ $t('Unlimited') }}</span>
              </div>
              <b-switch class="float-right is-rounded" style="margin-top: -25px"
                        :false-value="$store.getters.getSettings().YOUTUBE[0]"
                        :true-value="$store.getters.getSettings().YOUTUBE[1]"
                        v-model="pickedPlan.valueYouTube" size="is-medium"
                        type="is-success">
              </b-switch>
            </div>

            <hr style="margin: 0 auto; width: 95%;"/>

          </div>


          <div v-if="$store.state.is5GFeatureActive"
               :style="is5GDisabled ? 'opacity: 45%': ''"
               style="padding-top: 5px">

            <div class="align-left" style="margin-top: 5px;">
              <div>
                <img style="width: 100px;" alt="5G" src="../assets/5G.png">
              </div>
              <div class="display-inline-block">
                <span class="benefit-1">{{ $t('5GService') }}</span>
              </div>
              <b-switch class="float-right is-rounded" style="margin-top: -25px" :disabled="is5GDisabled"
                        :false-value="$store.getters.getSettings()['5G'][0]"
                        :true-value="$store.getters.getSettings()['5G'][1]"
                        v-model="pickedPlan.value5G" size="is-medium"
                        type="is-success">
              </b-switch>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div id="last"></div>
    <br/><br/>
    <br/><br/>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import smoothReflow from 'vue-smooth-reflow'
import 'vue-slider-component/theme/default.css'
import BSwitch from "buefy/src/components/switch/Switch"

export default {
  name: 'PlansSelector',
  props: ['plan'],
  mixins: [smoothReflow],
  components: { BSwitch, vueSlider },
  data() {
    return {
      cardStates: {
        SelectPlansView: 0,
        ConfirmPlanSelectionView: 1,
        ChangePlanInProgressView: 2,
        ChangePlanResultView: 3
      },
      cardState: 0,
      pickedPlan: {
        valueGBs: {},
        valueMinutesOnNet: {},
        valueMinutesOffNet: {},
        valueInternationalMinutes: {},
        valueWhatsApp: false,
        valueSocialMedia: false,
        valueYouTube: false,
        value5G: false
      },
      language: 'en',
      price: 0
    }
  },
  computed: {
    is5GDisabled() {
      return this.pickedPlan.valueGBs.value === '0.0'
          || this.price < 5
          || this.$store.state.userInfo.has5GAccessFee
    }
  },
  methods: {
    calculateTotal() {
      if (this.pickedPlan.valueMinutesOffNet.isUnlimited) {
        this.pickedPlan.valueMinutesOnNet = this.$store.getters.getSettings().ONNETMINUTES[0]
      }
      let price = (Object.values(this.pickedPlan).map(x => parseFloat(x.price)).reduce((previousValue, currentValue) => previousValue + currentValue))


      // if 5G is selected
      if (this.pickedPlan.value5G.value === '1.0') {

        // and (Total price - 5G Price < 5 --OR-- data value === 0) then deselect 5G
        if ((price - Number(this.pickedPlan.value5G.price) < 5) || this.pickedPlan.valueGBs.value === '0.0') {
          this.pickedPlan.value5G = this.$store.getters.getSettings()['5G'][0]
        }
      }

      this.$emit('pickedplan', { plan: this.pickedPlan, total: price.toFixed(3), planType: 'Custom' })
      this.price = price
    },
    getYouTubeVal() {
      if (this.$store.state.settingFuture) {
        let obj = JSON.parse(JSON.stringify(this.$store.getters.getSettings().YOUTUBE[1]))
        obj.price = 2
        return obj
      } else return this.$store.getters.getSettings().YOUTUBE[1]
    }
  },
  watch: {
    pickedPlan: {
      deep: true,
      handler: function () {
        this.calculateTotal()
      }
    }
  },
  mounted() {
    this.pickedPlan.valueGBs = this.plan.valueGBs
    this.pickedPlan.valueMinutesOnNet = this.plan.valueMinutesOnNet
    this.pickedPlan.valueMinutesOffNet = this.plan.valueMinutesOffNet
    this.pickedPlan.valueInternationalMinutes = this.plan.valueInternationalMinutes
    this.pickedPlan.valueSocialMedia = this.plan.valueSocialMedia
    this.pickedPlan.valueWhatsApp = this.plan.valueWhatsApp
    this.pickedPlan.valueYouTube = this.plan.valueYouTube
    this.pickedPlan.value5G = this.plan.value5G
  }
}
</script>

<style scoped>
.plan-card {
  background-color: rgba(255, 215, 0, 0);
  border-radius: 10px;
  text-align: left;
  color: black;
  margin: 0;
}

.card-header {
  background-color: #eeeeee;
  padding: 3px 10px 0;
  font-size: 1em;
}

.top-radius {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.card-footer {
  background-color: #ffd500;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 10px;
  min-height: 70px;
  border-top: inherit !important;
}

.slider-label {
  line-height: 1;
  text-align: center;
  width: 40px;
  position: relative;
  top: 13px;
  left: -15px;
  cursor: pointer;
  font-size: 0.85em;
  padding-top: 5px;
}

/*.vue-slider-mark:first-child .slider-label {*/
/*    left: -5px;*/
/*}*/

.vue-slider-mark:last-child .slider-label {
  left: -20px;
}

[dir='rtl'] .slider-label {
  left: 15px !important;
  text-align: center !important;
}

[dir='rtl'] .vue-slider-mark:last-child .slider-label {
  left: 24px !important;
}

.slider-dot {
  background-color: #7bc440;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  transform: translateY(100%);
}

.benefits-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.benefits-list li {
  height: 55px;
}

.benefit-1 {
  display: block;
  font-size: 0.9em;

  font-weight: bold;
  margin: 5px 0;
}


.display-inline-block {
  display: inline-block !important;
}

.promo-tag {
  margin: 2px 0 4px 0;
  display: inline-block;
  min-width: 10px;
  padding: 3px 6px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  border-radius: 10px;
  background: #ffd500;

}
</style>
